import {DigitalWalletActions, DigitalWalletActionTypes} from '../actions/digitalwallet.actions';
import {AppState} from './index';
import {createSelector} from '@ngrx/store';
import {DickerSelectListItem} from '../models/check-out.model';


export interface DigitalWalletState {
  loadError: string,
  loaded: boolean,
  customerPayments: DickerSelectListItem[]
}

export const initialState: DigitalWalletState = {
  loadError: null,
  loaded: false,
  customerPayments: []
};

export function digitalWalletReducer(
  state = initialState,
  action: DigitalWalletActions
): DigitalWalletState {
  switch (action.type) {
    case DigitalWalletActionTypes.Load:
      return {
        loaded: false,
        ...state,
      };
    case DigitalWalletActionTypes.LoadSuccess :
      return {
        ...state,
        loaded: true,
        customerPayments: action.payload
      };
    case DigitalWalletActionTypes.LoadFailure :
      return {
        ...state,
        loadError: action.payload
      };

    // case DigitalWalletActionTypes.EnableSuccess:
    //   const enabledPayments = state.customerPayments.map((m) => {
    //     if (m.out_customer_number == action.payload) {
    //       m.out_valid = 'Y';
    //     }
    //     return m;
    //   });
    //   return {
    //     ...state,
    //     customerPayments: enabledPayments
    //   };
    // case DigitalWalletActionTypes.EnableFailure:
    //   return {
    //     ...state
    //   };
    // case DigitalWalletActionTypes.DisableSuccess:
    //   const disabledPayments = state.customerPayments.map((m) => {
    //     if (m.out_customer_number == action.payload) {
    //       m.out_valid = 'N';
    //     }
    //     return m;
    //   });
    //   return {
    //     ...state,
    //     customerPayments: disabledPayments
    //   };
    // case DigitalWalletActionTypes.DisableFailure:
    //   return {
    //     ...state
    //   };

    default:
      return {
        ...state
      };
  }
}

export const selecDigitalWalletFeature = (state: AppState) => state.digitalWalletState;

export const getDigitalWalletLoaded = createSelector(
  selecDigitalWalletFeature,
  (state: DigitalWalletState) => state.loaded);

export const getDigitalWallets = createSelector(
  selecDigitalWalletFeature,
  (state: DigitalWalletState) => state.customerPayments);
